import styles from 'css/Switch.module.css'
import { useState, useRef, useEffect } from 'react'

const Switch = ({ children, name, on = true, onText, offText, onToggle, disabled = false }) => {

	const [onoff, setOn] = useState(on)
	const input = useRef()

	const onClick = () => {
		if (disabled) return false;
		setOn(!onoff)
		if (onToggle) onToggle(!onoff)
	}

	if (on === false) {
		if (onText === undefined) onText = children
		if (offText === undefined) offText = children
	}
	if (on === true) {
		if (onText === undefined) onText = children
		if (offText === undefined) offText = children
	}

	useEffect(() => {
		setOn(on)
	}, [on])

	return (
		<div className={onoff ? styles.default : styles.off} onClick={onClick}>
			{onoff ? onText : offText}
			<input ref={input} name={name} type="hidden" defaultValue={onoff} />
		</div>
	)
}

export default Switch